import { schemaTypes, dateFormat } from "../../../constants/constants";

const schema = {
  key: "download_report",
  name: "Download Report",
  toolbar: [],
  content: [
    {
      key: "download_report",
      name: "Download Report",
      type: schemaTypes.DOWNLOAD_REPORT,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};
export default schema;
